import React, { useEffect } from "react";
import { Button } from "reactstrap";

const ScrolltoTop: React.FC = () => {
  useEffect(() => {
    const btn = document.getElementById("back-to-top") as HTMLElement | null;
    if (!btn) return;

    function scrollFunction() {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        btn!.style.display = "block";
      } else {
        btn!.style.display = "none";
      }
    }

    window.addEventListener("scroll", scrollFunction, { passive: true });
    return () => window.removeEventListener("scroll", scrollFunction);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Button id="back-to-top" className="p-0" onClick={scrollTop}>
      <i className="mdi mdi-arrow-up"></i>
    </Button>
  );
};

export default ScrolltoTop;
